"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvStateMigrationComponentNames = exports.ComponentNames = void 0;
exports.convertProjectSettingsV2ToV3 = convertProjectSettingsV2ToV3;
exports.getComponent = getComponent;
exports.getComponentByScenario = getComponentByScenario;
exports.convertManifestTemplateToV3 = convertManifestTemplateToV3;
exports.convertManifestTemplateToV2 = convertManifestTemplateToV2;
const fs_extra_1 = require("fs-extra");
const lodash_1 = require("lodash");
const path_1 = require("path");
const projectSettingsHelper_1 = require("../common/projectSettingsHelper");
exports.ComponentNames = {
    TeamsTab: "teams-tab",
    TeamsBot: "teams-bot",
    TeamsApi: "teams-api",
    AppManifest: "app-manifest",
    AadApp: "aad-app",
    AzureWebApp: "azure-web-app",
    AzureStorage: "azure-storage",
    BotService: "bot-service",
    SPFxTab: "spfx-tab",
    SPFx: "spfx",
    Identity: "identity",
    APIM: "apim",
    KeyVault: "key-vault",
    AzureSQL: "azure-sql",
    TabCode: "tab-code",
    BotCode: "bot-code",
    ApiCode: "api-code",
    Function: "azure-function",
    SimpleAuth: "simple-auth",
    SSO: "sso",
    ApiConnector: "api-connector",
    CICD: "cicd",
};
exports.EnvStateMigrationComponentNames = [
    ["solution", "solution"],
    ["fx-resource-appstudio", exports.ComponentNames.AppManifest],
    ["fx-resource-identity", exports.ComponentNames.Identity],
    ["fx-resource-azure-sql", exports.ComponentNames.AzureSQL],
    ["fx-resource-aad-app-for-teams", exports.ComponentNames.AadApp],
    ["fx-resource-function", exports.ComponentNames.TeamsApi],
    ["fx-resource-apim", exports.ComponentNames.APIM],
    ["fx-resource-key-vault", exports.ComponentNames.KeyVault],
    ["fx-resource-bot", exports.ComponentNames.TeamsBot],
    ["fx-resource-frontend-hosting", exports.ComponentNames.TeamsTab],
    ["fx-resource-simple-auth", exports.ComponentNames.SimpleAuth],
];
function convertProjectSettingsV2ToV3(settingsV2, projectPath) {
    const settingsV3 = (0, lodash_1.cloneDeep)(settingsV2);
    const solutionSettings = settingsV2.solutionSettings;
    if (solutionSettings && (!settingsV3.components || settingsV3.components.length === 0)) {
        settingsV3.components = [];
        const isVS = (0, projectSettingsHelper_1.isVSProject)(settingsV2);
        const hasAAD = solutionSettings.activeResourcePlugins.includes("fx-resource-aad-app-for-teams");
        if (hasAAD) {
            settingsV3.components.push({
                name: exports.ComponentNames.AadApp,
                provision: true,
                deploy: true,
            });
        }
        if (solutionSettings.activeResourcePlugins.includes("fx-resource-frontend-hosting")) {
            const hostingComponent = isVS ? exports.ComponentNames.AzureWebApp : exports.ComponentNames.AzureStorage;
            const existsAuthStartFile = (0, fs_extra_1.pathExistsSync)((0, path_1.join)(projectPath, "tabs", "public", "auth-start.html"));
            const tabSSO = solutionSettings.capabilities.includes("TabSSO") ||
                solutionSettings.capabilities.includes("SSO") ||
                existsAuthStartFile;
            if (isVS) {
                const teamsTab = {
                    hosting: hostingComponent,
                    name: "teams-tab",
                    build: true,
                    provision: true,
                    folder: "",
                    artifactFolder: "bin\\Release\\net6.0\\win-x86\\publish",
                    sso: tabSSO,
                    deploy: true,
                };
                settingsV3.components.push(teamsTab);
            }
            else {
                const teamsTab = {
                    hosting: hostingComponent,
                    name: "teams-tab",
                    build: true,
                    provision: true,
                    folder: "tabs",
                    sso: tabSSO,
                    deploy: true,
                };
                settingsV3.components.push(teamsTab);
            }
            const hostingConfig = getComponent(settingsV3, hostingComponent);
            if (hostingConfig) {
                hostingConfig.connections = hostingConfig.connections || [];
                hostingConfig.connections.push("teams-tab");
            }
            else {
                settingsV3.components.push({
                    name: hostingComponent,
                    connections: ["teams-tab"],
                    provision: true,
                });
            }
        }
        if (solutionSettings.activeResourcePlugins.includes("fx-resource-spfx")) {
            const teamsTab = {
                hosting: "spfx",
                name: "teams-tab",
                build: true,
                provision: true,
                folder: "SPFx",
                deploy: true,
            };
            settingsV3.components.push(teamsTab);
            settingsV3.components.push({
                name: "spfx",
                provision: true,
            });
        }
        if (solutionSettings.activeResourcePlugins.includes("fx-resource-bot")) {
            const hostType = settingsV2.pluginSettings?.["fx-resource-bot"]?.["host-type"];
            let botCapabilities = settingsV2.pluginSettings?.["fx-resource-bot"]?.["capabilities"];
            if (solutionSettings.capabilities.includes("message-extension") &&
                !botCapabilities?.includes("message-extension")) {
                botCapabilities = botCapabilities || [];
                botCapabilities.push("message-extension");
            }
            const isHostingFunction = hostType === "azure-functions";
            const hostingComponent = isHostingFunction
                ? exports.ComponentNames.Function
                : exports.ComponentNames.AzureWebApp;
            if (isVS) {
                const teamsBot = {
                    name: "teams-bot",
                    hosting: hostingComponent,
                    build: true,
                    provision: true,
                    folder: "",
                    artifactFolder: "bin\\Release\\net6.0\\win-x86\\publish",
                    capabilities: botCapabilities,
                    sso: solutionSettings.capabilities.includes("BotSSO"),
                    deploy: true,
                };
                settingsV3.components.push(teamsBot);
            }
            else {
                const teamsBot = {
                    hosting: hostingComponent,
                    name: "teams-bot",
                    build: true,
                    provision: true,
                    folder: "bot",
                    capabilities: botCapabilities,
                    sso: solutionSettings.capabilities.includes("BotSSO"),
                    deploy: true,
                };
                settingsV3.components.push(teamsBot);
            }
            const hostingConfig = getComponent(settingsV3, hostingComponent);
            if (hostingConfig) {
                hostingConfig.connections = hostingConfig.connections || [];
                hostingConfig.connections.push("teams-bot");
            }
            else {
                settingsV3.components.push({
                    name: hostingComponent,
                    connections: ["teams-bot"],
                    provision: true,
                    scenario: "Bot",
                });
            }
            settingsV3.components.push({
                name: exports.ComponentNames.BotService,
                provision: true,
            });
        }
        if (solutionSettings.activeResourcePlugins.includes("fx-resource-identity")) {
            settingsV3.components.push({
                name: exports.ComponentNames.Identity,
            });
        }
        if (solutionSettings.activeResourcePlugins.includes("fx-resource-key-vault")) {
            settingsV3.components.push({
                name: exports.ComponentNames.KeyVault,
            });
        }
        if (solutionSettings.activeResourcePlugins.includes("fx-resource-azure-sql")) {
            settingsV3.components.push({
                name: exports.ComponentNames.AzureSQL,
                provision: true,
            });
        }
        if (solutionSettings.activeResourcePlugins.includes("fx-resource-apim")) {
            settingsV3.components.push({
                name: exports.ComponentNames.APIM,
                provision: true,
                deploy: true,
            });
        }
        if (solutionSettings.activeResourcePlugins.includes("fx-resource-simple-auth")) {
            settingsV3.components.push({
                name: exports.ComponentNames.SimpleAuth,
                provision: true,
            });
        }
        if (solutionSettings.activeResourcePlugins.includes("fx-resource-function")) {
            settingsV3.components.push({
                name: exports.ComponentNames.TeamsApi,
                hosting: exports.ComponentNames.Function,
                functionNames: [settingsV2.defaultFunctionName || "getUserProfile"],
                build: true,
                folder: "api",
                deploy: true,
                artifactFolder: "api",
            });
            settingsV3.components.push({
                name: exports.ComponentNames.Function,
                scenario: "Api",
            });
        }
        ensureComponentConnections(settingsV3);
    }
    return settingsV3;
}
const ComponentConnections = {
    [exports.ComponentNames.AzureWebApp]: [
        exports.ComponentNames.Identity,
        exports.ComponentNames.AzureSQL,
        exports.ComponentNames.KeyVault,
        exports.ComponentNames.AadApp,
        exports.ComponentNames.TeamsTab,
        exports.ComponentNames.TeamsBot,
        exports.ComponentNames.TeamsApi,
    ],
    [exports.ComponentNames.Function]: [
        exports.ComponentNames.Identity,
        exports.ComponentNames.AzureSQL,
        exports.ComponentNames.KeyVault,
        exports.ComponentNames.AadApp,
        exports.ComponentNames.TeamsTab,
        exports.ComponentNames.TeamsBot,
        exports.ComponentNames.TeamsApi,
    ],
    [exports.ComponentNames.APIM]: [exports.ComponentNames.TeamsTab, exports.ComponentNames.TeamsBot],
};
function getComponent(projectSettings, resourceType) {
    return projectSettings.components?.find((r) => r.name === resourceType);
}
var Scenarios;
(function (Scenarios) {
    Scenarios["Tab"] = "Tab";
    Scenarios["Bot"] = "Bot";
    Scenarios["Api"] = "Api";
})(Scenarios || (Scenarios = {}));
function getComponentByScenario(projectSetting, resourceType, scenario) {
    return scenario
        ? projectSetting.components?.find((r) => r.name === resourceType && r.scenario === scenario)
        : getComponent(projectSetting, resourceType);
}
function ensureComponentConnections(settingsV3) {
    const exists = (c) => getComponent(settingsV3, c) !== undefined;
    const existingConfigNames = Object.keys(ComponentConnections).filter(exists);
    for (const configName of existingConfigNames) {
        const existingResources = ComponentConnections[configName].filter(exists);
        const configs = settingsV3.components.filter((c) => c.name === configName);
        for (const config of configs) {
            config.connections = (0, lodash_1.cloneDeep)(existingResources);
        }
    }
    if (getComponent(settingsV3, exports.ComponentNames.TeamsApi) &&
        getComponent(settingsV3, exports.ComponentNames.APIM)) {
        const functionConfig = getComponentByScenario(settingsV3, exports.ComponentNames.Function, Scenarios.Api);
        functionConfig?.connections?.push(exports.ComponentNames.APIM);
    }
}
function convertManifestTemplateToV3(content) {
    for (const pluginAndComponentArray of exports.EnvStateMigrationComponentNames) {
        const pluginName = pluginAndComponentArray[0];
        const componentName = pluginAndComponentArray[1];
        if (pluginName !== componentName)
            content = content.replace(new RegExp(`state.${pluginName}`, "g"), `state.${componentName}`);
    }
    return content;
}
function convertManifestTemplateToV2(content) {
    for (const pluginAndComponentArray of exports.EnvStateMigrationComponentNames) {
        const pluginName = pluginAndComponentArray[0];
        const componentName = pluginAndComponentArray[1];
        if (pluginName !== componentName)
            content = content.replace(new RegExp(`state.${componentName}`, "g"), `state.${pluginName}`);
    }
    return content;
}
//# sourceMappingURL=migrate.js.map